// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yuh8D","wrapper":"styles_wrapper__ZEHKf","image":"styles_image__TWXxm","heading":"styles_heading__L0djX","para":"styles_para__pxocs"};